module.exports = __webpack_public_path__ + "img/GoTo_PartnerNetwork_Blk_Yel_HEX.e1bed27f.png";